// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"841c8d0d","619":"e02d64bd","646":"f5ea733c","802":"5bc58a0b","860":"6c9aa319"}[chunkId] + ".chunk.js";
};